import CheckoutError from '@/checkout/models/CheckoutError'
import Step from '@/shared/enums/Step'
import { AxiosError } from 'axios'

export interface Error {
  code: string
  message: string
  step?: Step
}

const defaultError: Error = {
  code: '00.00.0000',
  message: '',
}

export default function mapError(e?: AxiosError<CheckoutError>): Error {
  let code = defaultError.code
  let message = defaultError.message
  let step = defaultError.step

  const response = e?.response

  if (response) {
    const { status, data } = response

    if (data?.errors?.length) {
      const error = data.errors[0]

      if (status === 422 || status === 400) {
        message = 'message.invalidData'
        step = Step.infoForm
      }

      code = error.code
    }
  }

  return { code, message, step }
}
